import { render, staticRenderFns } from "./BonusRewardPopup.vue?vue&type=template&id=d2e27f04&scoped=true"
import script from "./BonusRewardPopup.vue?vue&type=script&lang=js"
export * from "./BonusRewardPopup.vue?vue&type=script&lang=js"
import style0 from "./BonusRewardPopup.vue?vue&type=style&index=0&id=d2e27f04&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2e27f04",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/centurygame/web-vip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d2e27f04')) {
      api.createRecord('d2e27f04', component.options)
    } else {
      api.reload('d2e27f04', component.options)
    }
    module.hot.accept("./BonusRewardPopup.vue?vue&type=template&id=d2e27f04&scoped=true", function () {
      api.rerender('d2e27f04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/features/popup-activities/plugins/bonus-reward/ui/BonusRewardPopup.vue"
export default component.exports